import LoggedOutAlertService from "./LoggedOutAlertService";

export interface IFetch {
  (input: RequestInfo, init?: RequestInit, token?: string): Promise<Response>;
}

class Fetcher {
  private static instance: Fetcher;

  constructor() {
    this.createRequest = this.createRequest.bind(this);
    this.fetch = this.fetch.bind(this);
  }

  private async createRequest(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const resp = await fetch(input, init);

    if (resp.status === 401) {
      LoggedOutAlertService.trigger();
    }

    return resp;
  }

  public async fetch(input: RequestInfo, init?: RequestInit, token?: string): Promise<Response> {
    if (token) {
      if (!init) {
        init = {};
      }
      if (!init.headers) {
        init.headers = {};
      }
      init.headers = { ...init.headers, Authorization: `Bearer ${token}` };
    }
    return await this.createRequest(input, init);
  }

  public static getInstance(): IFetch {
    if (!Fetcher.instance) {
      Fetcher.instance = new Fetcher();
    }
    return Fetcher.instance.fetch;
  }
}

export default Fetcher.getInstance();
